import cmsData from './cms/projects.json';

export const projects = cmsData.items.map((data) => ({
  id: data.id,
  name: data.title,
  image: data.image ?? null,
  logoImage: data.logoImage ?? null,
  tags: data.tags ?? [],
  upperDetail: data.upperDetail ?? null,
  lowerDetail: data.lowerDetail ?? null,
  projectOwner: data.projectOwner ?? null,
  // Short plain-text summary shown on the Our Works listing card. Optional —
  // mainly used for "html" projects whose upperDetail is markup, not prose.
  excerpt: data.excerpt ?? null,
  // "text" (default) = plain paragraphs; "html" = upperDetail is raw HTML
  // (rich case-study layout) rendered via dangerouslySetInnerHTML.
  contentFormat: data.contentFormat ?? "text",
  order: data.order ?? 99,
}));
// Order is preserved as-is from the JSON array (drag-and-drop order in CMS)
